<template>
    <div>
        <hr>
        <div class="flex gap-8">
            <img
                src="/images/desktop-click-deliver-map.jpg"
                alt="Click and Deliver Map"
                class="w-48 hidden md:block"
            >
            <div class="w-full">
                <div class="flex gap-4 mb-4">
                    <img
                        src="/images/mobile-click-deliver-map.jpg"
                        alt="Delivery Truck"
                        class="w-32 h-32 md:hidden aspect-square"
                    >
                    <div>
                        <h2 class="mb-3">
                            Check delivery availability
                        </h2>
                        <p class="font-bold">
                            {{ product ? 'This product is' : 'These products are' }} only available for delivery in some locations.
                        </p>
                        <p>
                            Use our delivery checker below to check whether we can deliver to your address.
                        </p>
                    </div>
                </div>

                <div>
                    <IdealPostcodesAutocomplete
                        placeholder="Enter your delivery address"
                        @selected="checkAddress($event)"
                    />
                </div>
            </div>

        </div>

        <p
            v-if="product"
            class="text-sm font-semibold text-primary mt-10 no-underline transition-fast opacity-75 cursor-pointer"
            @click="openDeliveryModal"
        >
            View list of available delivery areas
        </p>
        <hr>
    </div>
</template>
<script>
export default {
    props: {
        product: {
            type: Object,
            required: false,
            default: () => {},
        },
        shippingClass: {
            type: Number,
            required: true,
        },
    },

    methods: {
        checkAddress(address) {
            const productId = this.shippingClass;
            const shippingAddress = {
                firstLine: address.line_1 || '',
                secondLine: address.line_2 || '',
                city: address.post_town || '',
                county: address.county || '',
                country: address.country || '',
                postcode: address.postcode || '',
            };

            this.$store.dispatch('checkout/checkDeliveryAddressHasShippingRates', {
                shippingAddress,
                productId,
            });

            if (!this.$store.getters['basket/id']) {
                this.$store.dispatch('checkout/createOrder');
            } else {
                this.$store.dispatch('checkout/updateOrder');
            }
        },
        openDeliveryModal() {
            this.$modal.show('product-modals-modal', {
                title: 'Delivery',
                html: this.product.delivery_modal_html,
            });
        },
    },
};
</script>
